import { render, staticRenderFns } from "./WAOStudentForm.vue?vue&type=template&id=fcc6770c&scoped=true&"
import script from "./WAOStudentForm.vue?vue&type=script&lang=js&"
export * from "./WAOStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./WAOStudentForm.vue?vue&type=style&index=0&id=fcc6770c&prod&scoped=true&lang=scss&"
import style1 from "./WAOStudentForm.vue?vue&type=style&index=1&id=fcc6770c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc6770c",
  null
  
)

export default component.exports